import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/icons/zoom_out.png';
import _imports_1 from '@/assets/icons/zoom_in.png';
const _hoisted_1 = { class: "cropper-slider-navigation" };
const _hoisted_2 = { class: "cropper-slider-navigation__wrapper" };
const _hoisted_3 = { class: "cropper-slider-navigation__line" };
import { ref, onMounted, onUnmounted } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'UiImageSlider',
    props: {
        zoom: {
            type: Number,
            default: 0
        }
    },
    emits: ['change'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const focus = ref(false);
        const onDrag = (e) => {
            if (focus.value) {
                const position = e.touches ? e.touches[0].clientX : e.clientX;
                const line = document.querySelector('.cropper-slider-navigation__line-wrapper');
                if (line) {
                    const { left, width } = line.getBoundingClientRect();
                    emit('change', Math.min(1, Math.max(0, position - left) / width));
                }
                if (e.preventDefault) {
                    e.preventDefault();
                }
            }
        };
        const onStop = () => {
            focus.value = false;
        };
        const onStart = (e) => {
            focus.value = true;
            onDrag(e);
        };
        onMounted(() => {
            window.addEventListener('mouseup', onStop, { passive: false });
            window.addEventListener('mousemove', onDrag, { passive: false });
            window.addEventListener('touchmove', onDrag, { passive: false });
            window.addEventListener('touchend', onStop, { passive: false });
        });
        onUnmounted(() => {
            window.removeEventListener('mouseup', onStop);
            window.removeEventListener('mousemove', onDrag);
            window.removeEventListener('touchmove', onDrag);
            window.removeEventListener('touchend', onStop);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "cropper-slider-navigation__zoom-icon--left" }, [
                        _createElementVNode("span", { class: "material-symbols-outlined pushed-right" }, [
                            _createElementVNode("img", {
                                src: _imports_0,
                                alt: "zoom-out"
                            })
                        ])
                    ], -1)),
                    _createElementVNode("div", {
                        class: "cropper-slider-navigation__line-wrapper",
                        ref: "line",
                        onMousedown: onStart,
                        onTouchstart: onStart
                    }, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", {
                                class: "cropper-slider-navigation__fill",
                                style: _normalizeStyle({ flexGrow: props.zoom })
                            }, null, 4),
                            _createElementVNode("div", {
                                class: _normalizeClass(["cropper-slider-navigation__circle", { 'cropper-slider-navigation__circle--focus': focus.value }]),
                                style: _normalizeStyle({ left: `${__props.zoom * 100}%` })
                            }, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["cropper-slider-navigation__inner-circle", { 'cropper-slider-navigation__inner-circle--focus': focus.value }])
                                }, null, 2)
                            ], 6)
                        ])
                    ], 544),
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "cropper-slider-navigation__zoom-icon--right" }, [
                        _createElementVNode("span", { class: "material-symbols-outlined pushed-right" }, [
                            _createElementVNode("img", {
                                src: _imports_1,
                                alt: "zoom-in"
                            })
                        ])
                    ], -1))
                ])
            ]));
        };
    }
});
